// extracted by mini-css-extract-plugin
export default {"main":"styles_main__bOHZ+","topScroll":"styles_topScroll__9Zct3"};